import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UtilService } from '../util.service';
import { VenderApi } from './api-vender';

@Injectable({
  providedIn: 'root',
})
export class VenderGBService {
  constructor(
    private util: UtilService,
    public api: VenderApi,
    public storage: Storage
  ) {}

  // 取得團購數量統計 by site_codes(多個)
  get_gb_stat_by_site_codes(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/calc_count';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取得團購方案清單 by site
  get_gb_list_by_site(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy/list';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取得團購方案detail
  get_gb_detail_by_id(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy/detail';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 發起團購
  create_gbi(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/create';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 停止團購(manual stop, submit order)
  stop_gbi(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/stop';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取消團購(manual stop, cancel all orders)
  cancel_gbi(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/cancel';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取得團購實例清單 by site
  get_gbi_list_by_site(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/list_lite';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取得團購實例detail
  get_gbi_detail_by_id(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/detail';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取得團購的團員清單
  get_gbi_txn_list(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/joiners';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取得團購的退貨清單
  get_gbi_return_list(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/return_list';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取消團員的訂單
  cancel_gbi_txn(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/leave2';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 退貨 團員的訂單
  return_gbi_txn(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/return2';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 新增 團員的訂單
  add_gbi_txn(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/join2';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 加入團購
  join_gbi(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/join';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 退出團購
  leave_gbi(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/leave';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 取得我的團購清單
  get_my_joiners(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/my_joiners';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 建立商品評論
  gbi_item_comment(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/item_comment/create';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 標記訂單已領取
  mark_gbi_txn_received(data?: any): Promise<any> {
    let endpoint = 'appv2/vender/groupbuy_instance/update_txn_received_at';

    return new Promise(async (resolve, reject) => {
      let params: any = {};
      params.data = data;

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  private extractData(res) {
    console.log(res);
    let body = res; //httpclient , res已經是json
    console.log(body);
    if (body.returnCode === 'OK') {
      return body;
    } else {
      throw { api_error: true, message: body.message };
    }
  }
}
